module.exports = __webpack_public_path__ + "static/media/bank.3e333d44.png";